import fetchWithAuth from "@/plugins/fetch";

export async function fetchGetTraderDetail(trader: string): Promise<any> {
	return (await fetchWithAuth(`https://data.fogo.fluxbeam.xyz/traders/${trader}/detail`)).json();
}

export async function fetchGetTraderPnL(trader: string): Promise<any> {
	return (await fetchWithAuth(`https://data.fogo.fluxbeam.xyz/traders/${trader}/tokens/pnl`)).json();
}

export async function fetchGetTraderTokens(trader: string): Promise<any> {
	return (await fetchWithAuth(`https://data.fogo.fluxbeam.xyz/traders/${trader}/tokens`)).json();
}